<template>
  <v-card :loading="isGetConfigurationPending || messagesSaving">
    <v-card-title>
      <h1 class="headline">Registration Messages</h1>
    </v-card-title>
    <v-card-subtitle>
      <h2
        class="subtitle-1"
      >You can specifiy the messages the user sees before and after registration.</h2>
    </v-card-subtitle>
    <v-card-text v-if="registrationMessages">
      <v-row>
        <v-col class="px-4" cols="12" md="6" align-self="start">
          <v-textarea
            counter
            auto-grow
            prepend-icon="mdi-information"
            rows="6"
            label="Registration introduction"
            hint="Message is shown before registration prompts begin"
            v-model="registrationMessages.config.intro"
          ></v-textarea>
        </v-col>
        <v-col class="px-4" cols="12" md="6" align-self="start">
          <v-textarea
            counter
            auto-grow
            prepend-icon="mdi-check"
            rows="6"
            label="Registration completed"
            hint="Message is shown after a completed registration"
            v-model="registrationMessages.config.complete"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-btn class="mt-2 mr-2" color="primary" outlined @click="saveMessages()" :loading="messagesSaving">Save</v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { makeGetMixin } from "feathers-vuex";
import { mapActions } from "vuex";

export default {
  data: () => ({
    messagesSaving: false,
    registrationMessagesConfigId: "registrationMessages"
  }),
  mixins: [
    makeGetMixin({
      service: "configuration",
      id: "registrationMessagesConfigId",
    }),
  ],
  created() {},
  computed: {
    registrationMessages() {
      return this.configuration
    }
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    async saveMessages() {
      this.messagesSaving = true;
      await this.registrationMessages.save();
      this.showMessage({ text: "Messages saved!", color: "success" });
      this.messagesSaving = false;
    },
  },
  watch: {},
  props: {},
};
</script>